module.exports = __webpack_public_path__ + "static/media/contico.d540f131.png";